import { render, staticRenderFns } from "./HomePrivacy.vue?vue&type=template&id=d7c2b5f8&scoped=true"
import script from "./HomePrivacy.vue?vue&type=script&lang=js"
export * from "./HomePrivacy.vue?vue&type=script&lang=js"
import style0 from "./HomePrivacy.vue?vue&type=style&index=0&id=d7c2b5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c2b5f8",
  null
  
)

export default component.exports